// Portal Feature Flags Configuration
// Controls which features are visible in the client portal

export const portalFeatures = {
  // Navigation items
  navigation: {
    dashboard: true,       // Show dashboard for clients
    clients: true,         // Keep clients visible for PCM staff
    forms: true,           // Show forms & docs for questionnaire management
    engagements: true,     // Show engagements pipeline
    documents: true,       // Show documents
    messages: false,       // Hide messages
    support: false,        // Hide support
    analytics: false,      // Hide analytics
    settings: true,        // Keep settings visible
    history: true,         // Show history
    compliance: false      // Hide compliance
  },
  
  // Settings page features
  settings: {
    profile: true,         // Keep profile information visible
    security: false,       // Hide two-factor auth section
    notifications: true,   // Keep notification preferences
    billing: true          // Keep billing information if applicable
  },
  
  // Other features
  backToWebsite: true      // Keep back to website link
};

// Helper function to check if a navigation item should be shown
export const isNavigationItemVisible = (itemName: string): boolean => {
  return portalFeatures.navigation[itemName as keyof typeof portalFeatures.navigation] ?? false;
};

// Helper function to check if a settings section should be shown
export const isSettingsSectionVisible = (sectionName: string): boolean => {
  return portalFeatures.settings[sectionName as keyof typeof portalFeatures.settings] ?? false;
};